import { UseFormRegister } from "react-hook-form";
import { Task } from "../../../types/task";

interface Props {
    task: Task;
    register: UseFormRegister<Task>;
}

export function TitleInput({ task, register }: Props) {

    return (
        <input
            {...register("titulo")}
            disabled={task.estatus == "Terminada"}
            className="h-[40px] disabled:bg-white bg-transparent font-semibold text-3xl w-full my-3 focus:outline-none focus:ring-2 focus:ring-slate-600 focus:rounded"
            type="text"/>
    );
}